module.exports = __webpack_public_path__ + "img/plus.5cf7ec20.svg";